const giftCardHero = () => {
    window.GiftCardHeroCustom = {
        disableCartRedirect: true,
        cartCallback: function () {
            window.dispatchEvent(new CustomEvent('frank-green:gift-card-added-to-cart'));
        },
    };
};
export { giftCardHero };
